import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
    SavingsOvertimePointDto,
    SavingsOvertimeResponseDto,
} from '../types/ReportSavingsSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchSavingsOvertimeParams {
    dateFrom: string;
    dateTo: string;
    propertyIds?: string[];
    categoryIds?: string[];
    period?: 'day' | 'week' | 'month';
}

export const fetchSavingsOvertime = createAsyncThunk<
    SavingsOvertimePointDto[],
    FetchSavingsOvertimeParams,
    ThunkConfig<string>
>(
    'reportSavingsSummary/fetchSavingsOvertime',
    async (
        { dateFrom, dateTo, propertyIds, categoryIds, period },
        thunkApi,
    ) => {
        const { extra, rejectWithValue } = thunkApi;
        try {
            const params: Record<string, string> = {
                date_from: dateFrom,
                date_to: dateTo,
            };

            if (period) {
                params.period = period;
            }

            if (propertyIds?.length) {
                params.property_ids = propertyIds.join(',');
            }

            if (categoryIds?.length) {
                params.category_ids = categoryIds.join(',');
            }

            const response = await extra.api.get<SavingsOvertimeResponseDto>(
                '/v1/reports/savings-insights/overtime',
                {
                    params,
                },
            );

            return response.data?.items ?? [];
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
